module.exports = __webpack_public_path__ + "static/media/icon-ipm2-universe.ff2866d4.png";